import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {getRules} from '../../../api/api';
import Modal from '../modal';
import './style.scss';
import {
  defineIsLangCyrillic,
} from "../../../common";

/**
 * Модальное окно с правилами для фрибета (HOC для компонента Modal)
 *
 * @param {Object} props
 * @param {Boolean} props.visible Начальное состояние модального окна, true - открыто, false - закрыто
 * @param {Boolean} [props.withHeader=true] Нужно ли выводить в модальном окне header для title, true - нужно, false - не нужно
 * @param {Function} props.onClose Функция, срабатывающая при закрытии модального окна
 * @param {Number} props.promoId id фрибета, по которому берутся правила
 * @param {Number} props.langId id языка для правил
 * @param {String} props.lang язык ленда
 * @returns {JSX.Element|null}
 * @constructor
 */
const ModalRules = ({ visible, withHeader, onClose, promoId , langId, lang}) => {
  const [rules, setRules] = useState(null);
  const [dir, setDir] = useState('');
  const [title, setTitle] = useState(null);
  const [isLangCyrillic, setIsLangCyrillic] = useState(false);
  const brokenRules = '<p dir="ltr" style="text-align: center;">Извините, правила временно недоступны.</p><p dir="ltr" style="text-align: center;">Попробуйте позднее.</p>';
  const brokenRulesEn = '<p dir="ltr" style="text-align: center;">We’re sorry. Terms and Conditions are temporarily unavailable.</p><p dir="ltr" style="text-align: center;">Please try again later.</p>';

  useEffect(() => {
    setIsLangCyrillic(defineIsLangCyrillic(lang));
  },[]);

  useEffect(() => {
    if (langId && lang) {
      getRules(promoId, langId)
        .then(response => {
          const freebetRules = response.data.result.freebet_rules;
          setRules(freebetRules);
          if (freebetRules.includes('Terms and Conditions of the Promotion')) {
            setDir('ltr');
          }
        })

        .catch(() => {
          (lang === 'ru' || lang === 'ua' || lang === 'kz' || lang === 'uz' || lang === 'tm') ? setRules(brokenRules) : setRules(brokenRulesEn) //не передается функция isLangCyrillic, использовал костыль
        });

    }
  }, [langId, lang, isLangCyrillic]);


  useEffect(() => {
    !title && getTitle?.();
  }, [rules]);

  if (!rules) return null;

  const getTitle = () => {
    const rg = /<h1>([\s\S]+?)<\/h1>/gm;
    const result = rg.exec(rules);
    const [replace, title] = result || [];
    setRules(rules.replace(replace, ''));
    setTitle(title);
  };

  const renderHTML = () => <div id='rules-container' dangerouslySetInnerHTML={{ __html: rules }} />;

  return (
    <Modal
      dir={dir}
      onClose={onClose}
      visible={visible}
      title={title || ''}
      withHeader={withHeader}
    >
      {renderHTML()}
    </Modal>
  );
};

ModalRules.propTypes = {
  onClose: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  withHeader: PropTypes.bool,
  promoId: PropTypes.number.isRequired,
  langId: PropTypes.number.isRequired
};

ModalRules.defaultProps = {
  withHeader: true,
};

export default ModalRules;
